import React from 'react';
import styled from 'styled-components/macro';
import { theme, mixins, Main } from './styles';
import IconMoeDataLogo from "./moedatalogo";
const { colors } = theme;

const Login = styled(Main)`
  ${mixins.flexCenter};
  flex-direction: column;
  min-height: 100vh;
  svg {
    width: 300px;
    fill: white;
  }
`;
const LoginButton = styled.a`
  display: inline-block;
  background-color: ${colors.green};
  color: ${colors.white};
  border-radius: 30px;
  padding: 17px 35px;
  margin: 20px 0 70px;
  min-width: 160px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  text-align: center;
  &:hover,
  &:focus {
    background-color: ${colors.offGreen};
  }
`;

const LoginScreen = () => (
  <Login>
    <IconMoeDataLogo />
    <LoginButton>Release in 2021!</LoginButton>
  </Login>
);

export default LoginScreen;